import { Component, Input, ChangeDetectorRef, ContentChild, inject } from '@angular/core';
import { AccordionLazyDirective } from '@shared/directives/accordion-lazy.directive';
import { NgClass, NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'app-accordion-content',
  templateUrl: './accordion-content.component.html',
  styleUrls: ['./accordion-content.component.scss'],
  imports: [NgClass, NgTemplateOutlet],
})
export class AccordionContentComponent {
  private cd = inject(ChangeDetectorRef);

  @ContentChild(AccordionLazyDirective, { static: true })
  lazyContent: AccordionLazyDirective;

  @Input() shouldVirtuallyOpen: boolean = false;
  @Input() _isOpen = false;

  @Input()
  set isOpen(value: boolean) {
    if (this._isOpen !== value) {
      this._isOpen = value;
      this.cd.markForCheck();
    }
  }

  get isOpen() {
    return this._isOpen;
  }
}
